import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "troubleshooting"
    }}>{`Troubleshooting`}</h1>
    <p>{`If you're having trouble with your actions or activations, here are some common issues and solutions.`}</p>
    <h2 {...{
      "id": "the-pod-exceeded-its-local-storage-and-was-evicted-with-x-in-flight-activations"
    }}>{`The pod exceeded its local storage and was evicted with X in flight activations`}</h2>
    <p>{`The most common reasons for exceeding local storage for an action are:`}</p>
    <ul>
      <li parentName="ul">{`Writing too many verbose logs.`}</li>
      <li parentName="ul">{`Storing large files on local storage without cleaning them up.`}</li>
    </ul>
    <p>{`Please, refer to the local storage limit configured for an action, which can be found in `}<a parentName="p" {...{
        "href": "./system_settings.md"
      }}>{`System Settings`}</a>{` section.
Exceeding this limit will result in the action being terminated or not completing successfully.`}</p>
    <h3 {...{
      "id": "mitigation-strategies"
    }}>{`Mitigation Strategies`}</h3>
    <ul>
      <li parentName="ul">{`Logging: Use the `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aio-lib-core-logging"
        }}>{`@adobe/aio-sdk`}</a>{` library for logging. Ensure that you are using the `}<inlineCode parentName="li">{`DEBUG`}</inlineCode>{` logging level for development, and set your production `}<inlineCode parentName="li">{`AIO_LOG_LEVEL`}</inlineCode>{` env variable to `}<inlineCode parentName="li">{`INFO`}</inlineCode>{` or `}<inlineCode parentName="li">{`WARN`}</inlineCode>{`. This approach minimizes storage use while retaining critical log information necessary for troubleshooting.`}</li>
      <li parentName="ul">{`Logging: Avoid verbose logging and log only the necessary information.`}</li>
      <li parentName="ul">{`File Management: Always clean up files written to disk after function execution. Neglecting this can lead to storage bloat, preventing future actions from running as expected.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      